import CoProducerList from './CoProductorList';
import SideQuickCreate from './Partials/SideQuickCreate';
import useModalStore from '@/store/useModalStore';
import CustomSheet from '@/components/shared/Sheet/Sheet';
import { usePermissions } from '@/auth/PermissionsContext';

const CoProducerManagement = () => {
  const { modals, closeModal } = useModalStore();
  const { hasPermission } = usePermissions();
  const canInvite = hasPermission('coproducers.invite_coproducer');

  return (
    <>
      <CoProducerList />

      {canInvite && (
        <CustomSheet
          open={modals['invite-co-producer']}
          onClose={() => closeModal('invite-co-producer')}
        >
          <SideQuickCreate />
        </CustomSheet>
      )}
    </>
  );
};

export default CoProducerManagement;
